import "./buttons.scss";

import ICON from "../icons/closeWhite.svg";

export const CloseButton = (props: {
  onClick: () => void;
  id?: string;
}): JSX.Element => {
  return (
    <button
      id={props.id}
      className="rg-button more"
      title="Close"
      onClick={props.onClick}
    >
      <img src={ICON} alt="" />
    </button>
  );
};
